/**
 * MEU ERP API - Equipment Compatible Product Service
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
} from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable } from 'rxjs';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable()
export class EquipmentCompatibleProductService {
  protected basePath = '/';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration
  ) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * GET danh sách Compatible Products
   * Filter theo equipment_model_id: Filters=equipment_model_id==<uuid>
   */
  public apiEquipmentCompatibleProductsGet(
    filters?: string,
    sorts?: string,
    page?: number,
    pageSize?: number,
    equipmentModelId?: string,
    equipmentModelPrefixId?: string,
    brandId?: string,
    equipmentCategoryId?: string,
    equipmentTypeId?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<any>;
  public apiEquipmentCompatibleProductsGet(
    filters?: string,
    sorts?: string,
    page?: number,
    pageSize?: number,
    equipmentModelId?: string,
    equipmentModelPrefixId?: string,
    brandId?: string,
    equipmentCategoryId?: string,
    equipmentTypeId?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<any>>;
  public apiEquipmentCompatibleProductsGet(
    filters?: string,
    sorts?: string,
    page?: number,
    pageSize?: number,
    equipmentModelId?: string,
    equipmentModelPrefixId?: string,
    brandId?: string,
    equipmentCategoryId?: string,
    equipmentTypeId?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<any>>;
  public apiEquipmentCompatibleProductsGet(
    filters?: string,
    sorts?: string,
    page?: number,
    pageSize?: number,
    equipmentModelId?: string,
    equipmentModelPrefixId?: string,
    brandId?: string,
    equipmentCategoryId?: string,
    equipmentTypeId?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });
    if (filters !== undefined && filters !== null) {
      queryParameters = queryParameters.set('Filters', <any>filters);
    }
    if (sorts !== undefined && sorts !== null) {
      queryParameters = queryParameters.set('Sorts', <any>sorts);
    }
    if (page !== undefined && page !== null) {
      queryParameters = queryParameters.set('Page', <any>page);
    }
    if (pageSize !== undefined && pageSize !== null) {
      queryParameters = queryParameters.set('PageSize', <any>pageSize);
    }
    if (equipmentModelId !== undefined && equipmentModelId !== null) {
      queryParameters = queryParameters.set('equipmentModelId', <any>equipmentModelId);
    }
    if (equipmentModelPrefixId !== undefined && equipmentModelPrefixId !== null) {
      queryParameters = queryParameters.set('equipmentModelPrefixId', <any>equipmentModelPrefixId);
    }
    if (brandId !== undefined && brandId !== null) {
      queryParameters = queryParameters.set('brandId', <any>brandId);
    }
    if (equipmentCategoryId !== undefined && equipmentCategoryId !== null) {
      queryParameters = queryParameters.set('equipmentCategoryId', <any>equipmentCategoryId);
    }
    if (equipmentTypeId !== undefined && equipmentTypeId !== null) {
      queryParameters = queryParameters.set('equipmentTypeId', <any>equipmentTypeId);
    }

    let headers = this.defaultHeaders;

    let httpHeaderAccepts: string[] = [];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    const consumes: string[] = [];

    return this.httpClient.request<any>(
      'get',
      `${this.basePath}/api/equipmentCompatibleProducts`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * GET chi tiết Compatible Product
   */
  public apiEquipmentCompatibleProductsIdGet(
    id: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<any>;
  public apiEquipmentCompatibleProductsIdGet(
    id: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<any>>;
  public apiEquipmentCompatibleProductsIdGet(
    id: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<any>>;
  public apiEquipmentCompatibleProductsIdGet(
    id: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling apiEquipmentCompatibleProductsIdGet.'
      );
    }

    let headers = this.defaultHeaders;

    let httpHeaderAccepts: string[] = [];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    return this.httpClient.request<any>(
      'get',
      `${this.basePath}/api/equipmentCompatibleProducts/${encodeURIComponent(
        String(id)
      )}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * POST bulk tạo nhiều Compatible Products
   */
  public apiEquipmentCompatibleProductsBulkPost(
    body?: any,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<any>;
  public apiEquipmentCompatibleProductsBulkPost(
    body?: any,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<any>>;
  public apiEquipmentCompatibleProductsBulkPost(
    body?: any,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<any>>;
  public apiEquipmentCompatibleProductsBulkPost(
    body?: any,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;

    let httpHeaderAccepts: string[] = [];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    const consumes: string[] = [
      'application/json-patch+json',
      'application/json',
      'text/json',
      'application/_*+json',
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<any>(
      'post',
      `${this.basePath}/api/equipmentCompatibleProducts/bulk`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * POST tạo Compatible Product mapping
   */
  public apiEquipmentCompatibleProductsPost(
    body?: any,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<any>;
  public apiEquipmentCompatibleProductsPost(
    body?: any,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<any>>;
  public apiEquipmentCompatibleProductsPost(
    body?: any,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<any>>;
  public apiEquipmentCompatibleProductsPost(
    body?: any,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;

    let httpHeaderAccepts: string[] = [];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    const consumes: string[] = [
      'application/json-patch+json',
      'application/json',
      'text/json',
      'application/_*+json',
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<any>(
      'post',
      `${this.basePath}/api/equipmentCompatibleProducts`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * PUT cập nhật Compatible Product
   */
  public apiEquipmentCompatibleProductsIdPut(
    id: string,
    body?: any,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<any>;
  public apiEquipmentCompatibleProductsIdPut(
    id: string,
    body?: any,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<any>>;
  public apiEquipmentCompatibleProductsIdPut(
    id: string,
    body?: any,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<any>>;
  public apiEquipmentCompatibleProductsIdPut(
    id: string,
    body?: any,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling apiEquipmentCompatibleProductsIdPut.'
      );
    }

    let headers = this.defaultHeaders;

    let httpHeaderAccepts: string[] = [];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    const consumes: string[] = [
      'application/json-patch+json',
      'application/json',
      'text/json',
      'application/_*+json',
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<any>(
      'put',
      `${this.basePath}/api/equipmentCompatibleProducts/${encodeURIComponent(
        String(id)
      )}`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * DELETE xóa Compatible Product
   */
  public apiEquipmentCompatibleProductsIdDelete(
    id: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<any>;
  public apiEquipmentCompatibleProductsIdDelete(
    id: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<any>>;
  public apiEquipmentCompatibleProductsIdDelete(
    id: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<any>>;
  public apiEquipmentCompatibleProductsIdDelete(
    id: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling apiEquipmentCompatibleProductsIdDelete.'
      );
    }

    let headers = this.defaultHeaders;

    let httpHeaderAccepts: string[] = [];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    return this.httpClient.request<any>(
      'delete',
      `${this.basePath}/api/equipmentCompatibleProducts/${encodeURIComponent(
        String(id)
      )}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * POST gắn thêm các Tiền tố (Prefix) cho một Sự tương thích.
   * body: mảng UUID của Dòng Tiền Tố (equipment_model_prefix)
   * VD: ["40b8a05d-c5bf-4694-8250-7bc1ace5935a"]
   */
  public apiEquipmentCompatibleProductsIdPrefixesPost(
    id: string,
    prefixIds?: string[],
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling apiEquipmentCompatibleProductsIdPrefixesPost.'
      );
    }

    let headers = this.defaultHeaders;
    const consumes: string[] = [
      'application/json-patch+json',
      'application/json',
      'text/json',
      'application/_*+json',
    ];
    const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<any>(
      'post',
      `${this.basePath}/api/equipmentCompatibleProducts/${encodeURIComponent(
        String(id)
      )}/prefixes`,
      {
        body: prefixIds,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * DELETE loại bỏ một Prefix khỏi mapping tương thích.
   * {compatibleProductId}: id bản ghi tương thích
   * {prefixId}: UUID của tiền tố xe (equipment_model_prefix)
   */
  public apiEquipmentCompatibleProductsIdPrefixesPrefixIdDelete(
    compatibleProductId: string,
    prefixId: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (compatibleProductId === null || compatibleProductId === undefined) {
      throw new Error(
        'Required parameter compatibleProductId was null or undefined when calling apiEquipmentCompatibleProductsIdPrefixesPrefixIdDelete.'
      );
    }
    if (prefixId === null || prefixId === undefined) {
      throw new Error(
        'Required parameter prefixId was null or undefined when calling apiEquipmentCompatibleProductsIdPrefixesPrefixIdDelete.'
      );
    }

    return this.httpClient.request<any>(
      'delete',
      `${this.basePath}/api/equipmentCompatibleProducts/${encodeURIComponent(
        String(compatibleProductId)
      )}/prefixes/${encodeURIComponent(String(prefixId))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: this.defaultHeaders,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }
}
